export interface MainDashState {
  stcsDayList: StcsDayData[] | undefined;
  stcsAreaList: StcsAreaData[] | undefined;
  groupList: GroupListData[] | undefined;
  dronList: DronListData[] | undefined;
}

export interface StcsDayData {
  typeCd: string;
  count: number;
}

export interface StcsAreaData {
  typeCd: string;
  count: number;
}

export interface GroupListData {
  groupNm: string;
  groupId: string;
  joinDt: Date;
  createDt: Date;
}

export interface DronListData {
  arcrftModelNm: string;
  prdctNum: string;
  createDt: Date;
  groupNm: string;
}

export const initMainDash = {
  stcsDayList: undefined,
  stcsAreaList: undefined,
  groupList: undefined,
  dronList: undefined
};
